<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    append-to-body
    :close-on-click-modal='false'
    class="default-dialog cashierdiary--o-dialog"
    width="632px"
   >
    <div class="cashierdiary--o-dialog-wrapper" v-loading="loading">
      <!-- 字段名称 -->
      <div class="c-panel-name">
        <div class="c-panel-title">字段名称</div>
        <div class="c-panel-name-content">
          <el-input size="small" v-model="formData.columnName" placeholder="请输入字段名称"  class="c-panel-name-content-input" clearable></el-input>
          <div class="c-panel-name-content-example">
            <example-view :nowCustomType="formData.customType" :exampleName="value"></example-view>
          </div>
        </div>
      </div>
      <!-- 字段类别 -->
      <div class="c-panel-type">
        <div class="c-panel-title">类别</div>
        <div class="c-panel-type-content">
          <tab-view
            :list="typeOptions"
            @typeChange="typeChange"
            @refresh = "$emit('handleSuccess','0')"
            ref="tabViewRef"
            :nowCustomType="formData.customType"
          >
          </tab-view>
        </div>
      </div>
      <!-- 填写规则 -->
      <div class="c-panel-rule">
        <div class="c-panel-title">显示规则</div>
        <div class="c-panel-rule-content">
           <el-checkbox
             v-for="i in checkList"
             v-model="i.value"
             @change="handleCheckBox($event,i)"
             :key="i.id"
             class="c-panel-rule-content-checkBox"
            >
              <div class="c-panel-rule-content-checkBox-labelWrapper">
                <span>{{i.name}}</span>
                <public-tips :content="i.content"></public-tips>
              </div>
           </el-checkbox>
        </div>
      </div>
      <!-- 保存时校验 -->
      <div class="c-panel-check">
        <div class="c-panel-title">保存时校验</div>
        <el-checkbox v-model="formData.isStuff">
          <div class="c-panel-check-labelWrapper">
            <span>必须填</span>
            <public-tips content="选择后,填写字段时必填,否则无法保存"></public-tips>
          </div>
        </el-checkbox>
      </div>
      <!-- 操作按钮组 -->
      <div class="c-panel-btnGroup">
         <accBtn type="2" text="取消" @click="dialogVisible = false"></accBtn>
         <accBtn @click="handleSaveCustom"></accBtn>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import exampleView from "../dialogComponents/add-c-example.vue"
  import tabView from "../dialogComponents/add-c-type.vue"
  import publicTips from "@/components/publicTips/toolTip.vue"
  export default {
    components:{
      exampleView,tabView,publicTips
    },
    props:{
      title:{
        type:String,
        default:"新增字段"
      },
      row:{
        type: Object,
        default:()=>{ return {} }
      }
    },
    data() {
      return {
        loading:false,
        formData:{    // 公共参数
          id:"",
          columnName:"",  // 字段名称
          customType:"1", // 字段类型 1文本 2日期 3数值 4下拉 5图片 6按钮
          isStuff:false,  // 是否必填
          fillRule:"",  // 默认不选  0 收支都填 1 收入填写 2支出填写
        },
        dialogVisible:false,
        value:"",
        typeOptions:[], // 字段类别
        checkList:[
          {
            value:false,
            name:"收支都显示",
            id:0,
            content:"新增日记账时，选择收入或支出都会出现该字段"
          },{
            value:false,
            name:"仅收入时显示",
            id:1,
            content:"设置为仅\"收入\"时填写，新增日记账时，选择支出则不会出现该字段"
          },{
            value:false,
            name:"仅支出时显示",
            id:2,
            content:"设置为仅\"支出\"时填写，新增日记账时，选择收入则不会出现该字段"
          }
        ]
      }
    },
    created() {
      this.getCustomType();
    },
    watch:{
      dialogVisible(val) {
        if(val) {
          this.$emit("closeKeyWatch")
          if(this.row.id) {
            this.assignment(this.row);  // 修改赋值操作
          }else {
            this.resetValue();
          }
        }else {
          this.$emit("openKeyWatch")
        }
      },
    },
    methods:{
      // 编辑字段赋值操作
      assignment(val) {
        let customType = Number(val.customType);
        // 公共赋值
        this.formData.customType = customType;
        this.formData.columnName = val.columnName;
        this.formData.id = val.id;
        this.formData.isStuff = val.isStuff?true:false;
        this.formData.fillRule = val.fillRule;
        this.checkList.forEach(i=>{
          if(i.id === val.fillRule) {
            i.value = true;
          }else {
            i.value = false;
          }
        })
        // 类型赋值  选项和数值
        if(customType === 3 || customType === 4 || customType === 6) {
          this.$nextTick(()=>{
            this.$refs.tabViewRef.setNowValue(val,customType);
            this.$refs.tabViewRef.isEdit = true;
          })
        }
      },
      // 重置所有已选的
      resetValue() {
        this.formData.customType = 1;
        this.formData.columnName = "";
        this.formData.isStuff = false;
        this.formData.fillRule = "";
        this.formData.id = "";

        // 重置规则数组
        this.checkList.forEach(i=>{
          i.value = false;
        })
        this.$nextTick(()=>{
          this.$refs.tabViewRef.isEdit = false;
        })
      },
      // 最终保存用户所选
      handleSaveCustom() {
        this.testOk(()=>{
          let params = Object.assign({},this.formData,{
            isStuff:this.formData.isStuff?1:0,
          })
          switch(this.formData.customType) {
            case 3:   // 当前字段为数值
              let data = this.$refs.tabViewRef.getNowValue();
              if(data.valueType ==1&&!data.formula) return this.$message.warning("请编辑公式！");
              if(data.decimalNum_s&&!data.decimalNum&&data.decimalNum!==0) return this.$message.warning("请输入小数位数！");
              if(data.unitType ==2&&!data.unit) return this.$message.warning("请输入单位！");
              if(data.valueType!=="0"&&!data.formula) return this.$message.warning("请输入公式！");
              console.log(data)
              params = Object.assign({},params,{
                valueType:data.valueType ,
                formula:data.valueType==="0"?"":data.formula,
                formulaName:data.valueType==="0"?"":data.formulaName,
                decimalNum_s:data.decimalNum_s?1:0,
                decimalNum:data.decimalNum_s?data.decimalNum:0,
                unit:data.unitType==="2"?data.unit:"",
                isTotal:data.isTotal?1:0,
              })
              break;
            case 4:   // 当前字段为下拉选项
            case 6:   // 当前字段为按钮类型
              let data4 = this.$refs.tabViewRef.getNowValue();
              data4.optionList.forEach(i=>{
              	i.isDefault = i.isDefault?1:0;
              });
              params = Object.assign({},params,{
                ...data4
              })
              break;
            default:
              break;
          }
          this.loading = true;
         // console.log("保存：",params)
          this.$http.post('custom/saveCustomColumn' , params).then(res=>{
            this.loading = false;
          	if(res&&res.data.code == 1) {
          		this.$message.success(res.data.msg);
          		this.dialogVisible = false;
          		this.$emit('handleSuccess',"0");
          	}
          })
        })
      },
      // 检验函数
      testOk(callBack) {
        if(!this.formData.columnName&&this.formData.fillRule!==0) return this.$message.warning("请输入字段名称！")
        if(!this.formData.fillRule&&this.formData.fillRule!==0) return this.$message.warning("请选择显示规则！")
        callBack();
      },
      // 填写规则改变
      handleCheckBox(e,item) {
        this.checkList.forEach(i=>{
          i.value = false;
        })
        item.value = e;
        this.formData.fillRule =e?item.id:"";
      },
      // 类别改变
      typeChange(value) {
        if(this.row.id) { return this.$message.warning("禁止修改字段类型！") }
        this.formData.customType = value;
      },
      // 获取自定义类型类别
      getCustomType() {
        this.loading = true;
      	this.$http.post('custom/getCustomColumnTitle' , {}).then(res=>{
          this.loading = false;
      		if(res&&res.data.code == 1) {
      			this.typeOptions = res.data.data;
            this.formData.customType = this.typeOptions[0].customType;
      		}
      	})
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../../../assets/css/cashierdiary/dialog.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/add-c-dialog.vue